import {
  Button,
  FormControl,
  FormErrorMessage,
  HStack,
  Input,
  Text,
  VStack,
} from "@chakra-ui/react"
import { useTranslation } from "next-i18next"
import { useEffect, useState } from "react"
import {
  buildWorkspaceAuthUrl,
  isValidSubdomain,
  normalizeSubdomainInput,
} from "@/utils/workspaceSwitch"

// Only shown inside the native WebView shell (window.ReactNativeWebView),
// where there is no address bar: lets the user jump to another workspace's
// subdomain to sign in or register there. Same detection as
// pages/auth/login.tsx's sendIsLogged and BarCodeInput.
const WorkspaceSubdomainField = () => {
  const { t } = useTranslation()
  const [mounted, setMounted] = useState(false)
  const [value, setValue] = useState("")
  const [error, setError] = useState(false)

  useEffect(() => setMounted(true), [])

  if (!mounted || !window.ReactNativeWebView) return null

  const go = () => {
    const sub = normalizeSubdomainInput(value)
    if (!isValidSubdomain(sub)) {
      setError(true)
      return
    }
    window.location.assign(
      buildWorkspaceAuthUrl({
        subdomain: sub,
        rootDomain: process.env.NEXT_PUBLIC_ROOT_DOMAIN as string,
        pathname: window.location.pathname,
        search: window.location.search,
      })
    )
  }

  return (
    <VStack align="stretch" spacing={2} pt={4}>
      <Text fontSize="sm">{t("auth.workspace_prompt")}</Text>
      <FormControl isInvalid={error}>
        <HStack>
          <Input
            value={value}
            onChange={(e) => {
              setValue(e.target.value)
              setError(false)
            }}
            placeholder={t("auth.workspace_placeholder")}
            autoCapitalize="off"
            autoCorrect="off"
          />
          <Button onClick={go} variant="brand" flexShrink={0}>
            {t("auth.workspace_cta")}
          </Button>
        </HStack>
        <FormErrorMessage>{t("auth.workspace_invalid")}</FormErrorMessage>
      </FormControl>
    </VStack>
  )
}

export default WorkspaceSubdomainField
